import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { OneColumn, TwoColumns } from "@soqs/common";

import React from "react";
import { FormSpy } from "react-final-form";
import MultiLineField from "./usercomponents/MultiLineField";
import MalpracticeDescr from "./usercomponents/MalpracticeDescr";

const FraudInformation = (_props) => {
  const [textAreaCount, ChangeTextAreaCount] = React.useState(0);
  const recalculate = ({ values }) => {
    // console.log(e);
    ChangeTextAreaCount(values.incidentdescr?.length ?? 0);
  };

  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader title="Alleged Corruption Information" />
        <CardContent>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <OneColumn>
              <MultiLineField
                name="incidentdate"
                label="When did the incident/s occur"
                fieldlength={200}
                maxlength={200}
                rows={3}
                required={false}
              />
            </OneColumn>
            <OneColumn>
              <MultiLineField
                name="incidentplace"
                label="Where did the incident/s occur"
                fieldlength={200}
                maxlength={200}
                rows={3}
                required={false}
              />
            </OneColumn>
            <TwoColumns>
              <MalpracticeDescr
                name="incidentdescr"
                label="Description of Corruption or Malpractice "
                fieldlength={3000}
                minlength={100}
                rows={8}
                required={true}
              />
              <FormSpy onChange={recalculate} />
              {` ${textAreaCount} /3000`}
            </TwoColumns>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default FraudInformation;
